import React, { useEffect } from "react"
import styled from "styled-components"
import { Link } from "gatsby"

import { Subscribe } from "unstated"
import RPContainer from "../store"

import { AuthContainer } from "../stores/auth"
import { LogoDiv } from "./LandingBodyHelpers"

import plus from "../imgs/plus.svg"
import plusBlue from "../imgs/plus-blue.svg"
import wheel from "../imgs/wheel.svg"
import wheelBlue from "../imgs/wheel-blue.svg"
import { NotificationMenu } from "./NotificationMenu"
import ReactTooltip from "react-tooltip"
import { SignOutMenu } from "../components/SignOutMenu"

const MyDesktopNavbar = styled.nav`
  z-index: 200;

  top: 0;
  left: 0;
  width: 100%;
  display: block;
  // padding: 12px 0;
  position: fixed;
  box-shadow: 0 1px 3px 0 rgba(88, 98, 113, 0.06),
    0 0 0 1px rgba(25, 35, 50, 0.1);
  background-color: #ffffff;
  height: 66px;
  line-height: 1.15;

  .nav-div {
    max-width: 980px;
    width: 90%;
    height: 100%;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .nav-div-child {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  .nav-logo {
    text-decoration: none;
  }

  .nav-logo-img {
    height: 36px;
    display: block;
  }

  .middle-div {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
  }

  .last-div {
    margin: 0 0 0 14px;
    display: flex;
    justify-content: flex-end;
    flex-direction: row;
    align-items: center;
  }

  .last-div-child {
    padding: 0;
    color: #9ba1aa;
    font-weight: 500;
    font-size: 12px;
    line-height: 18px;
    letter-spacing: 0.6px;
    text-transform: uppercase;
    display: inline-block;
    text-decoration: none;
  }

  .reseller-button {
    background: rgba(102, 122, 244, 0.19);
    border-radius: 12px;
    color: #667af4;
    border: 0;
    padding: 10px 12px 10px 12px;
    text-align: center;
    font-weight: 400;
    font-size: 12px;
    line-height: 18px;
    cursor: pointer;
    &:disabled {
      background: rgba(102, 122, 244, 0.1);
      transform: scale(0.95);
      cursor: not-allowed;
    }
  }

  .user-id-wrapper {
    // position: fixed;
    // right: 24px;
    color: #9ba1aa;
    font-weight: 500;
    font-size: 12px;
    line-height: 18px;
    letter-spacing: 0.6px;
    cursor: pointer;
  }
`

const MidChild = styled.div`
  margin: 0 14px;
  .link {
    text-decoration: none;
    color: ${props => props.color};
  }

  .middle-div-child {
    display: flex;
    justify-content: flex-start;
    flex-direction: row;
    align-items: center;
  }

  .middle-div-child-logo {
    background-color: transparent;
    box-shadow: 0 0 0 2px ${props => props.color} inset;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 10px;
    width: 31px;
    height: 31px;
    min-width: 31px;
    min-height: 31px;
    border-radius: 50%;
    overflow: hidden;
    position: relative;
    user-select: none;
    transition: background-color 0.25s cubic-bezier(0.8, 0.3, 0.45, 0.95),
      box-shadow 0.25s cubic-bezier(0.8, 0.3, 0.45, 0.95);
  }

  .mdcl-child {
    width: 31px;
    height: 31px;
    min-width: 31px;
    min-height: 31px;
    position: relative;
    user-select: none;
    transition: color 0.25s cubic-bezier(0.8, 0.3, 0.45, 0.95),
      fill 0.25s cubic-bezier(0.8, 0.3, 0.45, 0.95);
    display: flex !important;
    align-items: center;
    flex-direction: column;
    justify-content: center;
  }

  .mdcl-child-para {
    color: ${props => props.color};
    font-weight: 500;
    transition: color 0.25s cubic-bezier(0.8, 0.3, 0.45, 0.95),
      fill 0.25s cubic-bezier(0.8, 0.3, 0.45, 0.95);
    text-align: center;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0.3px;
    margin: 0;
    padding: 0;
    white-space: normal;
  }

  .mdcl-child-img {
    display: block;
  }

  .middle-div-child-para {
    text-transform: uppercase;
    font-size: 12px;
    line-height: 18px;
    letter-spacing: 0.6px;
    font-weight: 700;
    margin: 0;
  }
`

const DesktopNavbar = ({ rpStore, location, isPublic, authStore }) => {
  useEffect(() => {
    if (authStore.isAuthenticated) {
      rpStore.fetchSubscriptions()
    }
    ReactTooltip.rebuild()
  }, [authStore.isAuthenticated, rpStore])

  const notLoggedIn =
    typeof authStore.state.user === "undefined"
      ? isPublic
      : !authStore.state.user
  const navLinks = notLoggedIn
    ? [
        {
          path: "/products",
          title: "Products",
        },
      ]
    : [
        {
          path: "/proxies",
          icon: rpStore => (
            <p className="mdcl-child-para">
              {rpStore.state.allSubscriptions.length}
            </p>
          ),
          title: "All My Proxies",
        },
        {
          path: "/addaproxy",
          icon: () => (
            <img
              className="mdcl-child-img"
              src={location.pathname.match("addaproxy") ? plusBlue : plus}
              alt="plus-sign"
            />
          ),
          title: "add a proxy",
        },
        {
          path: "/settings/account",
          icon: () => (
            <img
              className="mdcl-child-img"
              src={
                location.pathname.match("/settings/account") ? wheelBlue : wheel
              }
              alt="setting-sign"
            />
          ),
          title: "Account",
        },
      ]

  return (
    <MyDesktopNavbar>
      <div className="nav-div">
        <div className="nav-div-child">
          <LogoDiv dark />

          <div className="middle-div">
            {navLinks.map(link => (
              <MidChild
                key={link.path}
                color={
                  location.pathname.match(link.path) ? "#667af4" : "#9ba1aa"
                }
              >
                <Link to={link.path} className="link">
                  <div className="middle-div-child">
                    {link.icon && (
                      <div className="middle-div-child-logo">
                        <div className="mdcl-child">{link.icon(rpStore)}</div>
                      </div>
                    )}
                    <p className="middle-div-child-para">{link.title}</p>
                  </div>
                </Link>
              </MidChild>
            ))}
          </div>

          <div>
            <Link to={"/resellerrequest"} className="link">
              <button className="reseller-button">Reseller Request</button>
            </Link>
          </div>

          <div className="last-div">
            {!notLoggedIn && <NotificationMenu location={location} />}

            <div className="user-id-wrapper">
              {notLoggedIn ? (
                <a
                  className="last-div-child"
                  href="#log"
                  onClick={e => {
                    notLoggedIn ? authStore.login() : authStore.logout()
                    e.preventDefault()
                  }}
                >
                  sign {notLoggedIn ? "in" : "out"}
                </a>
              ) : (
                <SignOutMenu authStore={authStore} />
              )}
            </div>
          </div>
        </div>
      </div>
    </MyDesktopNavbar>
  )
}

const DesktopNavbarContainer = props => {
  return (
    <Subscribe to={[RPContainer, AuthContainer]}>
      {(rpStore, authStore) => (
        <DesktopNavbar
          {...{
            rpStore,
            authStore,
            ...props,
          }}
        />
      )}
    </Subscribe>
  )
}

export default DesktopNavbarContainer
